<script>
  import Footer from '../components/Footer.svelte';
  import Header from '../components/Header.svelte';
  import { privacyPage } from '../data/privacy.js';
  import { goBack } from '../utils/router.js';
</script>

<div id="top" class="privacy-page">
  <Header />

  <main class="privacy-main">
    <div class="privacy-shell">
      <button class="back-link" type="button" on:click={goBack}>
        <span class="back-icon" aria-hidden="true"></span>
        <span>{privacyPage.backLabel}</span>
      </button>

      <article class="privacy-content" aria-labelledby="privacy-title">
        <h1 id="privacy-title">{privacyPage.title}</h1>

        <div class="privacy-card">
          <div class="privacy-text">
            {#each privacyPage.blocks as block}
              {#if block.type === 'section'}
                <p class="privacy-section">{block.text}</p>
              {:else}
                <p>{block.text}</p>
              {/if}
            {/each}
            <p class="privacy-edition">{privacyPage.edition}</p>
          </div>
        </div>
      </article>
    </div>
  </main>

  <Footer />
</div>

<style>
  .privacy-page {
    min-height: 100vh;
    background: #000000;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .privacy-main {
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 100px 0;
  }

  .privacy-shell {
    display: flex;
    width: min(100%, 1440px);
    flex-direction: column;
    gap: 24px;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .back-link {
    display: inline-flex;
    width: fit-content;
    min-height: 40px;
    align-items: center;
    gap: 12px;
    margin: 0;
    padding: 6px 0;
    border: 0;
    background: transparent;
    color: inherit;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
    cursor: pointer;
  }

  .back-link:hover,
  .back-link:focus-visible {
    color: #e7b962;
  }

  .back-icon {
    display: inline-block;
    width: 7px;
    height: 14px;
    background: currentColor;
    -webkit-mask: url('/icons/ui-icon-chevron-right.svg') center / contain no-repeat;
    mask: url('/icons/ui-icon-chevron-right.svg') center / contain no-repeat;
    transform: rotate(180deg);
  }

  .privacy-content {
    display: flex;
    flex-direction: column;
    gap: 48px;
    padding: 40px 0 0;
  }

  h1 {
    margin: 0;
    color: #ffffff;
    font-size: 40px;
    font-weight: 700;
    line-height: 56px;
  }

  .privacy-card {
    padding: 40px 30px;
    border: 2px solid #ffa800;
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.72);
    box-sizing: border-box;
  }

  .privacy-text {
    color: #ffffff;
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
  }

  .privacy-text p {
    margin: 0;
  }

  .privacy-text p + p {
    margin-top: 4px;
  }

  .privacy-section {
    margin-top: 14px !important;
    color: #e7b962;
    font-weight: 500;
  }

  .privacy-section + p {
    margin-top: 6px !important;
  }

  .privacy-edition {
    margin-top: 14px !important;
  }

  @media (max-width: 1279px) {
    .privacy-main {
      padding: 100px 0;
    }

    .privacy-shell {
      gap: 24px;
      padding: 0 32px;
    }

    h1 {
      font-size: 36px;
    }

    .privacy-text {
      font-size: 22px;
      line-height: 34px;
    }
  }

  @media (max-width: 767px) {
    .privacy-main {
      padding: 100px 0 40px;
    }

    .privacy-shell {
      padding: 0 24px;
    }

    .privacy-content {
      gap: 24px;
    }

    h1 {
      font-size: 24px;
      line-height: 32px;
    }

    .privacy-card {
      padding: 24px 16px;
    }

    .privacy-text {
      font-size: 16px;
      line-height: 24px;
    }

    .privacy-section {
      margin-top: 12px !important;
    }

    .privacy-section + p {
      margin-top: 5px !important;
    }

    .privacy-edition {
      margin-top: 12px !important;
    }
  }
</style>
